import { h } from './index-662ec80e.js';

const propCheck = function (scope, propName, expectedType, expr) {
  delete scope.propError[propName];
  if (!expr(scope[propName]))
    return true;
  scope.propError[propName] = new TypeError(`TypeError on property ${scope.constructor.name}.${propName}\nExpected: ${expectedType} \nReceived: ${JSON.stringify(scope[propName])}\n`);
  return false;
};
const runWatchers = (scope) => {
  for (let key in scope) {
    const watcherName = 'watch' + key.charAt(0).toUpperCase() + key.slice(1);
    if (typeof scope[watcherName] === 'function')
      scope[watcherName](scope[key]);
  }
};
const hasPropError = (scope) => {
  return Object.values(scope.propError).length > 0;
};
const displayPropError = (scope) => {
  return h("ds-error", { message: Object.values(scope.propError)[0].message });
};

export { displayPropError as d, hasPropError as h, propCheck as p, runWatchers as r };
